export function getLoginWebsite(hostname) {
  const website = hostname.replace(/^www\./, "").replace(/^ag\./, "");
  return ["localhost", "127.0.0.1", "::1", "[::1]"].includes(website)
    ? "chorki.win"
    : website || "SABAEXCH";
}

export function getReadableApiMessage(message, fallback = "Unable to complete this request. Please try again.") {
  if (typeof message !== "string" || !message.trim()) return fallback;
  if (["notauthorise", "notauthorized", "notauthorised", "unauthorized"].includes(message.toLowerCase().replace(/[^a-z]/g, ""))) {
    return "This request was not authorized. Please check your account details or contact support.";
  }
  return message;
}
